import { render } from "./WalletsList.vue?vue&type=template&id=19101cd3&scoped=true"
import script from "./WalletsList.vue?vue&type=script&lang=js"
export * from "./WalletsList.vue?vue&type=script&lang=js"

import "./WalletsList.vue?vue&type=style&index=0&id=19101cd3&scoped=true&lang=css"

import exportComponent from "F:\\ssd_backup\\OpenServer\\domains\\paygate.admin-panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19101cd3"]])

export default __exports__